/* ============================================================
   Slappy · página de producto, combos y agregar rápido
   ============================================================ */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (c) => (window.themeCart && window.themeCart.formatMoney ? window.themeCart.formatMoney(c) : '$' + (c / 100).toFixed(2));
  const toast = (m) => { const t = $('#Toast'); if (!t) return; t.textContent = m; t.classList.add('is-visible'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-visible'), 2600); };

  /* ---------- Agregar varios productos al carrito ---------- */
  async function addItems(items) {
    const res = await fetch((window.theme && window.theme.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar.');
    if (window.themeCart) { await window.themeCart.refresh(); window.themeCart.open(); }
    return data;
  }
  window.slappyAddItems = addItems;

  /* ---------- Agregar rápido (carrito, carruseles, outfit) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = $('button', form);
    const id = Number(new FormData(form).get('id'));
    if (!id) return;
    btn && btn.classList.add('is-loading');
    try { await addItems([{ id, quantity: 1 }]); toast('Agregado al carrito'); }
    catch (err) { toast(err.message); }
    finally { btn && btn.classList.remove('is-loading'); }
  });

  /* ---------- Código de descuento en el carrito ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-coupon]');
    if (!f) return;
    e.preventDefault();
    const code = (new FormData(f).get('code') || '').toString().trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });

  /* ---------- Página de producto ---------- */
  function initPDP(root) {
    const product = JSON.parse($('[data-pdp-json]', root).textContent);
    const stock = JSON.parse(($('[data-pdp-stock-json]', root) || { textContent: '{}' }).textContent || '{}');
    const low = Number(root.dataset.lowStock) || 0;
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-button]', root);
    const addText = $('[data-add-text]', root);
    const track = $('[data-pdp-track]', root);
    const slides = $$('.pdp__slide', root);
    const dots = $$('.pdp__dots span', root);
    const counter = $('[data-pdp-current]', root);
    const form = $('form.product-form', root);

    const selected = () => product.options.map((_, i) => { const c = $(`input[data-opt-index="${i}"]:checked`, root); return c ? c.value : null; });
    const find = (opts) => product.variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));

    /* Galería */
    const goTo = (i, smooth = true) => {
      if (!track || !slides[i]) return;
      if (root.querySelector('.pdp__gallery--grid') && window.innerWidth > 989) {
        slides[i].scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
      } else {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
    };
    const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (track) {
      track.addEventListener('scroll', () => {
        const i = current();
        if (counter) counter.textContent = i + 1;
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      }, { passive: true });
      const prev = $('[data-pdp-prev]', root), next = $('[data-pdp-next]', root);
      prev && prev.addEventListener('click', () => goTo(Math.max(0, current() - 1)));
      next && next.addEventListener('click', () => goTo(Math.min(slides.length - 1, current() + 1)));
      root.addEventListener('keydown', (e) => {
        if (!e.target.closest('[data-pdp-gallery]')) return;
        if (e.key === 'ArrowRight') goTo(Math.min(slides.length - 1, current() + 1));
        if (e.key === 'ArrowLeft') goTo(Math.max(0, current() - 1));
      });
    }

    /* Zoom a pantalla completa */
    const lb = $('[data-lightbox]', root);
    $$('[data-zoom]', root).forEach((b) => b.addEventListener('click', () => {
      if (!lb || !lb.showModal) return;
      lb.showModal();
      const target = $(`[data-lb-index="${b.dataset.zoom}"]`, lb);
      target && target.scrollIntoView({ block: 'start' });
    }));

    /* Variante seleccionada */
    const shipLine = () => {
      const add = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 0 && w !== 6) k++; } return x; };
      const f = (d) => d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' });
      const from = $('[data-ship-from]', root), to = $('[data-ship-to]', root);
      if (from) from.textContent = f(add(new Date(), Number(root.dataset.shipMin) || 3));
      if (to) to.textContent = f(add(new Date(), Number(root.dataset.shipMax) || 7));
    };
    shipLine();

    const markSoldOut = () => {
      // Tacha las opciones que no tienen ninguna variante disponible con la selección actual
      const sel = selected();
      product.options.forEach((_, oi) => {
        $$(`input[data-opt-index="${oi}"]`, root).forEach((input) => {
          const trial = sel.slice(); trial[oi] = input.value;
          const v = product.variants.find((x) => x.options.every((o, i) => o === trial[i]));
          const lbl = root.querySelector(`label[for="${input.id}"]`);
          if (lbl) lbl.classList.toggle('is-out', !v || !v.available);
        });
      });
    };

    const update = (scroll = true) => {
      const opts = selected();
      opts.forEach((v, i) => { const l = $(`[data-pdp-opt-label="${i}"]`, root); if (l && v != null) l.textContent = v; });
      const v = find(opts);
      markSoldOut();
      if (!v) { if (addBtn) addBtn.disabled = true; if (addText) addText.textContent = 'No disponible'; return; }
      idInput.value = v.id;
      $$('[data-pdp-price]', root).forEach((el) => (el.textContent = money(v.price)));
      const atcPrice = $('[data-pdp-atc-price]', root); if (atcPrice) atcPrice.textContent = money(v.price);
      const cmp = $('[data-pdp-compare]', root), save = $('[data-pdp-save]', root);
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmp) { cmp.hidden = !sale; if (sale) cmp.textContent = money(v.compare_at_price); }
      if (save) { save.hidden = !sale; if (sale) $('[data-pdp-save-pct]', save).textContent = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price); }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      const stickyBtn = $('[data-pdp-sticky-btn]', root); if (stickyBtn) stickyBtn.disabled = !v.available;
      const sv = $('[data-pdp-sticky-variant]', root); if (sv) sv.textContent = v.title;
      // Últimas piezas
      const st = $('[data-pdp-stock]', root), q = stock[v.id];
      if (st) {
        if (v.available && q != null && q > 0 && q <= low) { st.hidden = false; $('span', st).textContent = q === 1 ? '¡Última pieza en esta talla!' : `Solo quedan ${q} piezas en esta talla`; }
        else st.hidden = true;
      }
      // Imagen de la variante
      if (scroll && v.featured_media) {
        const idx = slides.findIndex((s) => s.dataset.mediaId == v.featured_media.id);
        if (idx > -1) goTo(idx);
      }
      // Outfit
      const om = $('[data-outfit-main-price]', root);
      if (om) { om.dataset.cents = v.price; om.textContent = money(v.price); const ov = $('[data-outfit-main-variant]', root); if (ov) ov.textContent = v.title; }
      updateOutfit();
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    root.addEventListener('change', (e) => { if (e.target.matches('input[data-opt-index]')) update(); });

    /* Arma tu outfit */
    const outfit = $('[data-outfit]', root);
    function updateOutfit() {
      if (!outfit) return;
      let total = Number(($('[data-outfit-main-price]', outfit) || {}).dataset.cents) || 0, count = 1;
      $$('.outfit__row:not(.outfit__row--main)', outfit).forEach((row) => {
        const on = $('[data-outfit-check]', row).checked;
        row.classList.toggle('is-off', !on);
        if (!on) return;
        const sel = $('[data-outfit-variant]', row);
        const cents = sel.tagName === 'SELECT' ? Number(sel.selectedOptions[0].dataset.cents) : Number(sel.dataset.cents);
        total += cents; count++;
      });
      const t2 = Number(outfit.dataset.tier2) || 0, t3 = Number(outfit.dataset.tier3) || 0;
      const pct = count >= 3 ? t3 : count === 2 ? t2 : 0;
      const final = Math.round(total * (100 - pct) / 100);
      $('[data-outfit-total]', outfit).textContent = money(final);
      $('[data-outfit-count]', outfit).textContent = count;
      const s = $('[data-outfit-saving]', outfit);
      s.innerHTML = pct ? `<s>${money(total)}</s> Ahorras ${pct}% al pagar` : 'Agrega otra prenda para ahorrar';
    }
    if (outfit) {
      outfit.addEventListener('change', updateOutfit);
      $('[data-outfit-add]', outfit).addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        const items = [{ id: Number(idInput.value), quantity: 1 }];
        $$('.outfit__row:not(.outfit__row--main)', outfit).forEach((row) => {
          if (!$('[data-outfit-check]', row).checked) return;
          items.push({ id: Number($('[data-outfit-variant]', row).value), quantity: 1 });
        });
        btn.classList.add('is-loading');
        try { await addItems(items); toast(items.length > 1 ? `Outfit agregado (${items.length} prendas)` : 'Agregado al carrito'); }
        catch (err) { toast(err.message); }
        finally { btn.classList.remove('is-loading'); }
      });
    }

    /* Favoritos (en este dispositivo) */
    const fav = $('[data-fav]', root);
    if (fav) {
      const key = 'slappy_favs';
      const read = () => { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } };
      const sync = () => { const on = read().includes(fav.dataset.fav); fav.classList.toggle('is-on', on); fav.setAttribute('aria-pressed', on); };
      fav.addEventListener('click', () => {
        let list = read(); const h = fav.dataset.fav;
        list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
        try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        sync(); toast(list.includes(h) ? 'Guardado en favoritos' : 'Quitado de favoritos');
      });
      sync();
    }

    /* Barra fija */
    const sticky = $('[data-pdp-sticky]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', !show);
      }).observe(addBtn);
      $('[data-pdp-sticky-btn]', sticky).addEventListener('click', () => { form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click(); });
    }

    /* Vistos recientemente */
    try {
      const key = 'slappy_recent';
      const list = (JSON.parse(localStorage.getItem(key)) || []).filter((h) => h !== root.dataset.productHandle);
      list.unshift(root.dataset.productHandle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}

    markSoldOut();
    update(false);
  }

  /* ---------- Vistos recientemente (sección) ---------- */
  async function initRecent(sec) {
    const track = $('[data-recent-track]', sec);
    let list = [];
    try { list = JSON.parse(localStorage.getItem('slappy_recent')) || []; } catch (e) {}
    const exclude = sec.dataset.exclude;
    list = list.filter((h) => h && h !== exclude).slice(0, 8);
    if (!list.length) { sec.hidden = true; return; }
    const cards = await Promise.all(list.map((h) => fetch(`/products/${h}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    const html = cards.filter((c) => c.includes('scard')).map((c) => `<div class="prail__slide">${c}</div>`).join('');
    if (!html) { sec.hidden = true; return; }
    track.innerHTML = html;
    sec.hidden = false;
  }

  function boot(scope = document) {
    $$('[data-pdp]', scope).forEach(initPDP);
    $$('[data-recent]', scope).forEach(initRecent);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
